import getData from '@services/api/common/getData';
import appConfig from '@configs/appConfig';

export const checkCoupon = code =>
  code
    ? getData(`${appConfig.baseUrl}/Account/check-code?code=${code}`)
    : Promise.resolve({ data: null });

export default {};
